/**
 * FLO Design System v2 - LoadingSpinner Component
 */

import React from 'react';

export function LoadingSpinner({
  size = 'md',
  color = 'red',
  message = null,
  className = ''
}) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4'
  };

  const borderColorClasses = {
    red: 'border-red-800',
    blue: 'border-blue-600',
    gray: 'border-gray-600',
    purple: 'border-purple-600',
    green: 'border-green-600'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size] || sizeClasses.md} ${borderColorClasses[color] || borderColorClasses.red} animate-spin rounded-full border-t-transparent`}
        style={{ borderTopColor: 'transparent' }}
      />
      {message && (
        <span className="ml-2 text-gray-600">{message}</span>
      )}
    </div>
  );
}
